// extracted by mini-css-extract-plugin
export default {"root":"ThreadView_root__QTdlV","open":"ThreadView_open__cpDoZ"};